
const initialState = JSON.parse(localStorage.getItem("intentList")) || [];

const  intentListReducer = (state = initialState,action) => {
    switch(action.type){
        case "JUNE_INTENT_LIST":
            localStorage.setItem("intentList", JSON.stringify(action.payload));
            return {...state, ...action.payload};

        default :
            return state;
    }
}

export default intentListReducer;